import { firstFromSnapshot } from "@buildwithflux/firestore-compatibility-layer";
/**
 * Firestore interface to user handle data.  Handles are stored in the database as a one-to-one mapping between handle and user_uid.
 * This data is only used by the login/register flow to have a quick way to determine if a handle is taken or not - it should not be
 * used as a source of truth about a user's handle (although it can serve as one).
 *
 * In general, pulling the handle straight off of the IUserData object is preferred.
 */
export class FirestoreHandleRepository {
    db;
    constructor(db) {
        this.db = db;
    }
    /** @inheritDoc */
    delete(mapping) {
        return this.db.handleMapping(mapping.userHandle).delete().then();
    }
    /**
     * Get the handle mapping for a given uid, if one exists.  Note that this should _always_ return a valid mapping
     * if the uid being passed in is a valid uid.
     *
     * @param userUid Uid for the user
     * @returns The handle mapping for this user if one exists, otherwise returns undefined.
     */
    async getByUserUid(userUid) {
        return firstFromSnapshot(await this.db.handleMappingCollection().where("user_uid", "==", userUid).get(), () => undefined);
    }
    async getByOrganizationUid(organizationUid) {
        return firstFromSnapshot(await this.db.handleMappingCollection().where("organizationUid", "==", organizationUid).get(), () => undefined);
    }
    /**
     * Get the user mapping for a given handle.
     *
     * @param handle The handle to query for.
     * @returns The handle mapping, if it exists.
     */
    async getByHandle(handle) {
        return this.db
            .handleMapping(handle)
            .get()
            .then((snap) => snap.data());
    }
    /**
     * Create a new mapping entry in the database.
     */
    async save(data) {
        return this.db.handleMapping(data.userHandle).set(data).then();
    }
    /**
     * Delete a mapping from the db.
     */
    async destroy(mapping) {
        return this.db.handleMapping(mapping.userHandle).delete().then();
    }
}
//# sourceMappingURL=FirestoreHandleRepository.js.map